import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { PageRequestInstanceDTO } from "src/app/parametrage/core/model/page-request-instance-dto";
import { PageRequest } from "src/app/parametrage/core/model/page-request";
import { PageCorrectionHistory } from "src/app/mon-portefeuille/core/model/page-correction-history";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { CreateDossierCorporate } from "../model/corporate/create-dossier-corporate";
import { PageCorrectionsHistory } from "src/app/parametrage/core/model/PageCorrectionHistoryDTO";
import { PageDemandeResurmeDTO } from "src/app/parametrage/core/model/page-demande-resurme-dto";
import { PageRequestDTO } from 'src/app/core/services/business/model/page-request-dto';

@Injectable({
  providedIn: "root",
})
export class CorporateService {
  constructor(private _restClientService: RestClientService) {}

  findAllDossierEncours(filter, page, size) {
    return this._restClientService.load<PageRequestInstanceDTO>(
      "corporate/find-all-dossier-encours" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  findAllDossierAbandonne(filter, page, size) {
    return this._restClientService.load<PageRequestInstanceDTO>(
      "corporate/find-all-dossier-abandonne" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  findAllDossierClotureCardView(filter, state, page, size) {
    return this._restClientService.load<PageDemandeResurmeDTO>(
      "corporate/find-all-dossier-cloture-card-view" +
        "?filter=" +
        filter +
        "&state=" +
        state +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  findAllDossierAcorrigerCardView(filter, page, size, sortColomun, descending) {
    return this._restClientService.load<PageCorrectionsHistory>(
      "corporate/find-all-dossier-a-corriger-card-view" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColomun=" +
        sortColomun +
        "&descending=" +
        descending
    );
  }

  findAllDossierCloture(filter, state, page, size) {
    return this._restClientService.load<PageRequest>(
      "corporate/find-all-dossier-cloture" +
        "?filter=" +
        filter +
        "&state=" +
        state +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  findAllDossier(filter,state:String[], debut, fin, page,size, sortColumn, direction) 
  {
      return this._restClientService.load<PageRequestDTO>('corporate/find-all-dossier'
      +'?filter='+filter
      +'&state='+state
      +'&debut='+debut
      +'&fin='+fin
      +'&page='+page
      +'&size='+size
      +'&sortColumn='+sortColumn
      +'&direction='+direction
      );
  }
  
  findAllDossierAcorriger(filter, page, size, sortColomun, descending) {
    return this._restClientService.load<PageCorrectionHistory>(
      "corporate/find-all-dossier-a-corriger" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColomun=" +
        sortColomun +
        "&descending=" +
        descending
    );
  }

  getCorporateByRequestId(requestId) {
    return this._restClientService.load<Corporate>(
      "corporate/find-customer-by-request/" + requestId
    );
  }

  createDossier(createDossierCorporate: CreateDossierCorporate) {
    return this._restClientService.save<void>(
      "corporate/create-dossier",
      createDossierCorporate
    );
  }
}
